import { useState } from "react";
import { X } from "lucide-react";
import api from "../../services/api";
import AssistantPermissions from "./AssistantPermissions";

export default function CreateMemberModal({ onClose, onSave, leaders }) {
  var formState = useState({ name: "", email: "", password: "", specialty: "consorcio", role: "broker", team_leader_id: "" });
  var form = formState[0]; var setForm = formState[1];
  var loadingState = useState(false);
  var errorState = useState(null);
  var permsState = useState({
    clientes: { view: true, edit: true },
    leads: { view: true, edit: true },
    consorcios: { view: true, edit: false },
    seguros: { view: true, edit: false },
    comissoes: { view: false },
    pagamentos: { view: false },
    agenda: { view: true, edit: true },
    comunicacao: { view: false },
    banners: { view: false },
    relatorios: { view: false },
    indicacoes: { view: false },
    equipe: { view: false },
    doletas: { view: false },
  });

  function updateField(f, v) { setForm(function(p) { var n = {}; for (var k in p) n[k] = p[k]; n[f] = v; return n; }); }

  function togglePerm(mod, action) {
    permsState[1](function(prev) {
      var n = {};
      for (var k in prev) { n[k] = {}; for (var a in prev[k]) n[k][a] = prev[k][a]; }
      n[mod][action] = !n[mod][action];
      if (action === "edit" && n[mod]["edit"]) n[mod]["view"] = true;
      if (action === "view" && !n[mod]["view"]) n[mod]["edit"] = false;
      return n;
    });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.password) return;
    loadingState[1](true); errorState[1](null);
    try {
      var payload = {
        name: form.name.trim(),
        email: form.email.trim().toLowerCase(),
        password: form.password,
        role: form.role,
        specialty: form.specialty,
        team_leader_id: form.team_leader_id || null,
      };
      if (form.role === "assistant") {
        payload.permissions = permsState[0];
      }
      await api.post("/auth/register", payload);
      onSave();
    } catch(err) {
      var detail = err.response?.data?.detail || "Erro ao cadastrar";
      errorState[1](typeof detail === "string" ? detail : "Erro ao cadastrar");
    } finally { loadingState[1](false); }
  }

  var isAssistant = form.role === "assistant";

  return (
    <div>
      <div className="fixed inset-0 bg-black/40 z-50" onClick={onClose} />
      <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-full max-w-md" data-testid="create-member-modal">
        <div className="bg-white rounded-2xl shadow-2xl max-h-[85vh] overflow-y-auto">
          <div className="flex items-center justify-between p-5 border-b border-gray-100">
            <h2 className="text-lg font-bold text-[#0A2F3D]">Novo Membro</h2>
            <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg"><X className="w-5 h-5 text-gray-500" /></button>
          </div>
          {errorState[0] && <div className="mx-5 mt-3 px-4 py-2.5 rounded-lg text-sm bg-red-50 text-red-700 border border-red-200">{errorState[0]}</div>}
          <form onSubmit={handleSubmit} className="p-5 space-y-4">
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1.5">Nome Completo *</label>
              <input type="text" value={form.name} onChange={function(e) { updateField("name", e.target.value); }}
                className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
                placeholder="Nome completo" required data-testid="member-form-name" />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1.5">Email *</label>
              <input type="email" value={form.email} onChange={function(e) { updateField("email", e.target.value); }}
                className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
                placeholder="email@methos.com.br" required data-testid="member-form-email" />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1.5">Senha *</label>
              <input type="password" value={form.password} onChange={function(e) { updateField("password", e.target.value); }}
                className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
                placeholder="Minimo 6 caracteres" required minLength={6} data-testid="member-form-password" />
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Cargo</label>
                <select value={form.role} onChange={function(e) { updateField("role", e.target.value); }}
                  className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30"
                  data-testid="member-form-role">
                  <option value="broker">Corretor</option>
                  <option value="team_leader">Lider de Equipe</option>
                  <option value="assistant">Assistente</option>
                </select>
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Especialidade</label>
                <select value={form.specialty} onChange={function(e) { updateField("specialty", e.target.value); }}
                  className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30"
                  data-testid="member-form-specialty">
                  <option value="consorcio">Consórcio</option>
                  <option value="seguros">Seguros</option>
                  <option value="plano_saude">Plano de Saúde</option>
                  <option value="ambos">Todos</option>
                </select>
              </div>
            </div>
            {form.role === "broker" && leaders && leaders.length > 0 && (
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Lider de Equipe</label>
                <select value={form.team_leader_id} onChange={function(e) { updateField("team_leader_id", e.target.value); }}
                  className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30"
                  data-testid="member-form-leader">
                  <option value="">Sem lider</option>
                  {leaders.map(function(l) { return <option key={l.id} value={l.id}>{l.name}</option>; })}
                </select>
              </div>
            )}
            {isAssistant && <AssistantPermissions permissions={permsState[0]} onToggle={togglePerm} />}
            <div className="flex gap-3 pt-1">
              <button type="button" onClick={onClose} className="flex-1 px-4 py-2.5 border border-gray-200 rounded-xl text-sm font-medium text-gray-600 hover:bg-gray-50">Cancelar</button>
              <button type="submit" disabled={loadingState[0]} className="flex-1 px-4 py-2.5 bg-[#3B82F6] text-white rounded-xl text-sm font-medium hover:bg-[#2563EB] disabled:opacity-50" data-testid="member-form-submit">
                {loadingState[0] ? "Criando..." : "Criar Membro"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
